import Component from '../inherited/Component'
import Helpers from '../lib/Helpers' 

export default class CollectionLimit extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    this.setHTML()

    document.addEventListener('bc--updated', e => {
      this.setHTML()
    })
  }

  setHTML () {
    if (Helpers.getQueryParam('limit')) {
      this._elem.innerHTML = Helpers.getQueryParam('limit')
    } else {
      this._elem.innerHTML = this._options.default
    }
  }
}